import { resourceState, resourceMutations } from '@/store/utils/resource';
import { AUTOMATIONS } from '@/store/entities/schema_types';
import { projectAutomationsClient as client } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  actions: {
    async load(ctx, { projectUuid, params = {} }) {
      try {
        const response = await client.list(projectUuid, { params });
        const { data } = response.data;
        const automationUuids = await ctx.dispatch('persist', { type: AUTOMATIONS, data });
        ctx.commit('setIds', automationUuids);
        return Promise.resolve({
          automationUuids,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },

    async store(ctx, { projectUuid, formData = {} }) {
      try {
        const response = await client.store(projectUuid, formData);
        const { data } = response.data;
        const automationUuid = await ctx.dispatch('persist', { type: AUTOMATIONS, data });
        ctx.commit('setIds', [...ctx.state.ids, automationUuid]);
        return Promise.resolve({
          automationUuid,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },

    persist(ctx, { type, data }) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type,
          data,
        },
        { root: true }
      );
    },
  },

  getters: {
    automations({ ids }, getters, { entities }) {
      return ids.map((id) => entities.automations.byId[id]);
    },
  },
};
